export const isRetainFundsEnabled = (accountNumber: string, wasClosingFeeTaken: boolean): boolean => {
  const firstChar = accountNumber.charAt(0).toUpperCase()
  return (firstChar === 'C' || firstChar === 'F' || firstChar === 'G') && wasClosingFeeTaken
}
